import React from 'react';
import PropTypes from 'prop-types';
import buildResourcePath from '../../buildResourcePath';
import Loader from './Loader';

/**
 * Simple button component with customizable theme, color and size.
 */
export default class Button extends React.Component {

    /** Specifies possible button themes. */
    static Theme = {
        Filled: 'filled',
        BorderOnly: 'border-only',
        TextOnly: 'text-only',
        Transparent: 'transparent'
    }

    static Shape = {
        Rectangle: 'rectangle',
        Circle: 'circle'
    }

    /** Specifies possible button colors. */
    static Color = {
        Default: 'default',
        Gray: 'gray',
        White: 'white'
    }

    /** Specifies possible button sizes. */
    static Size = {
        Tiny: 'tiny',
        Small: 'small',
        Default: 'default',
        Big: 'big'
    }

    static propTypes = {
        size: PropTypes.string,
        theme: PropTypes.string,
        color: PropTypes.string,
        shape: PropTypes.string,
        disabled: PropTypes.bool,
        onClick: PropTypes.func
    }

    static defaultProps = {
        size: Button.Size.Default,
        theme: Button.Theme.Filled,
        color: Button.Color.Default,
        shape: Button.Shape.Rectangle,
        disabled: false,
        processing: false
    }

    onClick = e => {
        if (!this.props.disabled && this.props.onClick) {
            this.props.onClick(e)
        }
    }

    render() {
        const rootClassNames = [
            'button-v2',
            'button-size-' + this.props.size,
            'button-theme-' + this.props.theme,
            'button-shape-' + this.props.shape,
            (this.props.disabled ? 'button-disabled' : 'button-color-' + this.props.color),
            (this.props.icon ? 'button-has-icon' : ''),
            this.props.className
        ]

        const IconComponent = this.props.icon;

        return (
            <div className="button-container" style={{position: 'relative'}}>
                <button className={rootClassNames.join(' ')} onClick={this.onClick} style={this.props.style}
                        id={this.props.id || ''}>
                    {this.props.icon && (
                        <span className="button-v2-icon">
                            <IconComponent size={IconComponent.Size.Small}/>
                        </span>
                    )}
                    {this.props.children}
                </button>
                {this.props.processing && <Loader fillContainer={true} showBalls={true}/>}
            </div>

        )
    }
}
